import { Link } from "react-router-dom";
import "./LoginMessage.css"; // Add styles for this component
// import animationImg from "../assets/login-animation.gif"; // Add an animation/image

const LoginMessage = () => {
  return (
    <div className="login-message-container">
      <div className="login-message">
        {/* <img src={animationImg} alt="Login to Access" className="login-animation" /> */}
        <h2>Login to Access Our Services</h2>
        <p>Please log in to your account to view this content.</p>
        <Link to="/my-account">
          <button className="login-btn">Go to My Account</button>
        </Link>
      </div>
    </div>
  );
};

export default LoginMessage;
